import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Paper, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ReturnIcon,
  CancelIcon,
  LadditionSymbolIcon,
  TrashIcon,
  ShareIcon,
} from 'images/svg';
import { Link, useHistory } from 'react-router-dom';
import { useAtom } from 'jotai';
import {
  tipsAtom,
  stepPaymentTicketAtom,
  shareNoteAtom,
  displayShareTicketAtom,
  activePersonalizedTipsAtom,
} from 'Atoms/Ticket';
import { displayClearCookiesAtom } from 'Atoms/Common';

const useStyles = makeStyles((theme) => ({
  paper: {
    zIndex: 9999999,
    position: 'relative',
  },
  container: {
    padding: '10px',
    borderBottom: '1px solid #d5d5d5',
    height: '57px',
  },
  title: theme.title,
  actionLabel: {
    display: 'inline-block',
    marginLeft: '7px',
    fontSize: '17px',
  },
  action: {
    whiteSpace: 'nowrap',
    '& svg': {
      verticalAlign: 'sub',
    },
  },
  nextAction: {
    textAlign: 'right',
  },
}));
const Header = ({ title, actions }) => {
  const classes = useStyles();
  const history = useHistory();
  const { prev, next } = actions || {};

  const [, setStepPaymentTicket] = useAtom(stepPaymentTicketAtom);
  const [, setShareNote] = useAtom(shareNoteAtom);
  const [, setDisplayClearCookies] = useAtom(displayClearCookiesAtom);
  const [, setDisplayShareTicket] = useAtom(displayShareTicketAtom);
  const [activePersonalizedTips, setActivePersonalizedTips] = useAtom(
    activePersonalizedTipsAtom,
  );
  const [tips, setTips] = useAtom(tipsAtom);
  const redirect = (e, to) => {
    e.preventDefault();
    setStepPaymentTicket('selected');
    if (to && !to.includes('tips')) {
      setShareNote({ selected: '', value: null, condition: null });
    }

    setActivePersonalizedTips(false);
    setTips(0);
    history.push(to);
  };

  const activeAction = (e, action) => {
    e.preventDefault();
    switch (action) {
      case 'clearCookies':
        return setDisplayClearCookies(true);
      case 'shareTicket':
        return setDisplayShareTicket(true);
      default:
        return;
    }
  };

  return (
    <Paper elevation={0} square={true} className={classes.paper}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.container}
      >
        <Grid item xs={3} className={classes.action}>
          {prev && prev.path && (
            <Link to={{}} onClick={(e) => redirect(e, prev.path)}>
              {Icon(prev?.icon)}
              <Typography color="secondary" className={classes.actionLabel}>
                {prev.label}
              </Typography>
            </Link>
          )}
        </Grid>
        <Grid item>
          <h1 className={classes.title}>{title}</h1>
        </Grid>
        <Grid item xs={3} className={`${classes.action} ${classes.nextAction}`}>
          {next && next.path && (
            <Link to={{}} onClick={(e) => redirect(e, next.path)}>
              {Icon(next?.icon)}
              <Typography color="secondary" className={classes.actionLabel}>
                {next.label}
              </Typography>
            </Link>
          )}
          {next && !next.path && next.action && (
            <Link to={{}} onClick={(e) => activeAction(e, next.action)}>
              {Icon(next?.icon)}
              <Typography color="secondary" className={classes.actionLabel}>
                {next.label}
              </Typography>
            </Link>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

const Icon = (name) => {
  switch (name) {
    case 'return':
      return <ReturnIcon />;
    case 'cancel':
      return <CancelIcon />;
    case 'laddition':
      return <LadditionSymbolIcon />;
    case 'trash':
      return <TrashIcon />;
    case 'shareTicket':
      return <ShareIcon />;
    default:
      return;
  }
};

Header.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.shape({
    icon: PropTypes.string,
    prev: PropTypes.object,
    next: PropTypes.object,
    action: PropTypes.string,
  }),
};

export default Header;
